import { Theme } from '@mui/material/styles'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(4),
  },
  cardProperties: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(2),
    alignSelf: 'stretch',
  },
  logoPositionSection: {
    maxWidth: theme.spacing(60.125),
    height: theme.spacing(7),
    display: 'flex',
    flexDirection: 'row',
    marginTop: theme.spacing(4),
  },
  logoPositionText: {
    width: '100%',
    maxWidth: theme.spacing(25),
    lineHeight: '20px',
    fontSize: '14px',
    fontWeight: 500,
    letterSpacing: '0.1px',
    fontFamily: theme.typography.fontFamily,
    color: '#6A777A',
  },
  horizontalDivider: {
    height: theme.spacing(0.125),
    backgroundColor: theme.palette.dividerV2.main,
    margin: theme.spacing(3, -4, 1, -4),
  },
  radiobuttonStyle: {
    marginRight: theme.spacing(-2.875),
  },
  alignmentAndOrientationContainer: {
    color: '#6A777A',
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '0.1px',
    width: theme.spacing(25),
  },
  icon: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(1.625),
    borderRadius: theme.spacing(0.5),
    border: `1px solid ${theme.palette.cardBorder.dark}`,
    background: theme.palette.background.paper,
    cursor: 'pointer',
  },
  alignmentIcon: {
    width: theme.spacing(5),
    height: theme.spacing(5),
    fontWeight: 400,
  },
  selected: {
    borderRadius: `${theme.spacing(0.5)} !important`,
    backgroundColor: `${theme.palette.bgTertiary.main} !important`,
    border: `2px solid ${theme.palette.button.secondary}  !important`,
  },
  orientationCard: {
    width: theme.spacing(15),
    height: theme.spacing(11),
    display: 'flex',
    padding: theme.spacing(2),
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(1.625),
    borderRadius: theme.spacing(0.5),
    border: `1px solid ${theme.palette.cardBorder.dark}`,
    background: theme.palette.background.paper,
    cursor: 'pointer',
  },
  orientationText: {
    color: theme.palette.black.main,
    fontFamily: theme.typography.fontFamily,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.15px',
  },
  verticalOrientation: {
    marginBottom: theme.spacing(-3),
  },
  horizontalOrientation: {
    marginBottom: theme.spacing(-5),
  },
  orientation: {
    borderRadius: theme.spacing(0.37),
    background: theme.palette.canvas.main,
    backgroundBlendMode: 'multiply',
    alignSelf: 'stretch',
  },
  vertical: {
    width: theme.spacing(4.5),
    height: theme.spacing(6.37),
    alignSelf: 'center',
  },
  horizontal: {
    width: theme.spacing(11),
    height: theme.spacing(3.62),
    alignSelf: 'center',
  },
  root: {
    backgroundColor: theme.palette.background.paper,
  },
  content: {
    padding: theme.spacing(4, 5),
  },
  sectionWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    height: 'auto',
  },
  textContentWrapper: {
    gap: theme.spacing(1.25),
  },
  textHeading: {
    color: '#381E1C',
    fontFamily: theme.typography.fontFamily,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '24px',
    letterSpacing: '0.25px',
  },
}))
